import React from "react"
export default function Header(props) {
    return <h3 id={props.id}>{props.headerText}</h3>
}
